import { gql } from "@apollo/client";

export const FETCH_TEAMS = gql`
  query TeamsList {
    teamsList {
      id
      name
      description
      visibility
    }
  }
`;

export const FETCH_TEAM_CHANNELS = gql`
  query TeamChannels($teamId: String!) {
    teamChannels(teamId: $teamId) {
      id
      name
      description
      membershipType
    }
  }
`;

export const CREATE_TEAMS_SUBSCRIPTION = gql`
  mutation CreateTeamsSubscription(
    $teamId: String!
    $teamName: String!
    $channelId: String!
    $channelName: String!
    $hours: Int
    $notificationUrl: String
    $clientState: String
  ) {
    createTeamsSubscription(
      teamId: $teamId
      teamName: $teamName
      channelId: $channelId
      channelName: $channelName
      hours: $hours
      notificationUrl: $notificationUrl
      clientState: $clientState
    ) {
      ok
      message
      subscription {
        teamId
        channelId
        subscriptionId
        status
        notificationUrl
        lifecycleNotificationUrl
        expirationDatetime
        lastError
      }
    }
  }
`;

export const FETCH_TEAMS_SUBSCRIPTIONS = gql`
  query TeamsSubscriptions(
    $teamId: String
    $channelId: String
    $status: String
    $includeRemoved: Boolean
    $limit: Int
  ) {
    teamsSubscriptions(
      teamId: $teamId
      channelId: $channelId
      status: $status
      includeRemoved: $includeRemoved
      limit: $limit
    ) {
      teamId
      teamName
      channelId
      channelName
      subscriptionId
      status
      clientState
      notificationUrl
      lifecycleNotificationUrl
      expirationDatetime
      lastRenewedAt
      lastError
      createdAt
      updatedAt
    }
  }
`;

export const CANCEL_TEAMS_SUBSCRIPTION = gql`
  mutation CancelTeamsSubscription(
    $subscriptionId: String!
    $localOnly: Boolean
  ) {
    cancelTeamsSubscription(
      subscriptionId: $subscriptionId
      localOnly: $localOnly
    ) {
      ok
      message
      graphStatusCode
      localUpdated
    }
  }
`;

export const FETCH_CHANNEL_SNAPSHOTS = gql`
  query TeamsChannelSnapshots(
    $teamId: String!
    $channelId: String!
    $includeDeleted: Boolean
    $options: CommonOptionsInput
  ) {
    teamsChannelSnapshots(
      teamId: $teamId
      channelId: $channelId
      includeDeleted: $includeDeleted
      options: $options
    ) {
      total
      results {
        messageId
        replyToId
        threadId
        createdDatetime
        lastModifiedDatetime
        fromUserDisplayName
        fromUserId
        isDeleted
        text
        rawHtml
        imageUrls
      }
    }
  }
`;
